import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { FEATURE_TOGGLER, HybridFeatureTogglerService } from '@cbre/feature-toggles';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuardService {
  constructor(
    @Inject(FEATURE_TOGGLER) private featureToggler: HybridFeatureTogglerService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const featureFlagKey = route.data.featureFlag;
    const redirectTo = route.data.redirectTo ?? null;

    return this.featureToggler.loadFeatureFlags()?.pipe(
      map(() => {
        // If no feature flag is specified, allow access by default
        if (!featureFlagKey || this.featureToggler.isFeatureEnabled(featureFlagKey)) {
          return true;
        }

        if (redirectTo != null) {
          this.redirectToHome(redirectTo);
        }
        return false;
      })
    );
  }

  private redirectToHome(redirectTo: any[]): void {
    this.router.navigate(redirectTo);
  }
}
